import {biErrorCodes} from './BIErrors'

export class BIEventTracker {
  constructor(reporter) {
    this.store = null
    this.reporter = reporter
    this.trackedEvents = {click: {}}
    this.lastBITarget = null
  }

  config = (params) => {
    this.trackedEvents = params

    const enterKeyHandler = (e) => {
      if (e.key === 'Enter') {
        this.clickHandler(e)
      }
    }

    if (this.trackedEvents.click && Object.keys(this.trackedEvents.click).length) {
      document.addEventListener('click', this.clickHandler, true)
      document.addEventListener('keydown', enterKeyHandler, true)
    } else {
      document.removeEventListener('click', this.clickHandler, true)
      document.removeEventListener('keydown', enterKeyHandler, true)
    }
  }

  setStore = (store) => {
    this.store = store
  }

  getLastBITarget = () => this.lastBITarget

  // dataset is not working for IE 11
  getDataFromElement = (element, key) =>
    element.getAttribute(`data-${key}`)

  clickHandler = (e) => {
    try {
      let domElement = e.target
      while (domElement && ! this.getDataFromElement(domElement, 'bi-target')) {
        // console.log('Checking dom element - ', domElement)
        domElement = domElement.parentElement
      }

      if (! domElement) {
        this.lastBITarget = null
        return
      }

      const biTarget = this.getDataFromElement(domElement, 'bi-target')
      this.lastBITarget = biTarget
      // console.log(`BITarget found: ${this.getDataFromElement(domElement, 'bi-target')}`)

      const clickHandlers = this.trackedEvents.click[biTarget]
      if (clickHandlers) {
        const state = this.store && this.store.getState()
        clickHandlers.forEach(clickHandler => {
          const eventToReport = clickHandler(e, biTarget, domElement, state)
          if (eventToReport) {
            this.reporter.reportEvent(eventToReport)
          }
        })
      }
    } catch (error) {
      this.reporter.logError(new Error('Error while handling event in biEventTracker'),
        {errorCode: biErrorCodes.eventHandlerError, error, event: e})
    }
  }
}
